// Exposing all callables to the client

export { callables as workspaces } from "./workspaces/callables";
export { callables as presentations } from "./presentations/callables";
export { callables as slides } from "./slides/callables";
export { callables as clientLogs } from "./clientLogs/callables";
export { callables as experiments } from "./experiments/callables";
export { callables as debug } from "./debug/callables";
export { callables as player } from "./player/callables";
export { callables as sharedThemes } from "./sharedThemes/callables";
export { callables as comments } from "./comments/callables";
export { callables as icons } from "./icons/callables";
export { callables as ai } from "./ai/callables";
